module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/logo_teams.26e51741a64dfbf4b0830b2f5577b575.svg";